/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'table-column-plus-after': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M11 2a2 2 0 012 2v16a2 2 0 01-2 2H2V2h9m-7 8v4h7v-4H4m0 6v4h7v-4H4M4 4v4h7V4H4m11 7h3V8h2v3h3v2h-3v3h-2v-3h-3v-2z"/>'
  }
})
